/**
 * Created by Reda on 11.02.2026.
 */

AdventureExpedition.register_testadv_quests = function () {
    this.createQuestsConfig("testadv", {
        deleteRpcustomermain3_0: true
    });
};
